import { useMemo } from 'react';
import { FieldType, SourceType } from 'components/organisms/tasks/fields';
import { useTranslation } from 'hooks/use-translation';
import { useProjectTemplates } from 'queries';
import { getRandomColor } from 'utils/get-random-color';
export const useTemplateField = (fieldId)=>{
    const { data: templates = [] } = useProjectTemplates();
    const fieldLabel = useTranslation('project.fields.template');
    return useMemo(()=>({
            templateField: {
                type: FieldType.MultiSelect,
                customField: false,
                fieldId,
                fieldName: 'template',
                fieldLabel,
                metaData: {
                    options: (templates !== null && templates !== void 0 ? templates : []).map((x)=>{
                        var _x_templateName;
                        return {
                            label: (_x_templateName = x.templateName) !== null && _x_templateName !== void 0 ? _x_templateName : '',
                            value: x.templateId,
                            color: getRandomColor(x.templateId),
                            active: true
                        };
                    })
                },
                private: true,
                sourceType: SourceType.Project
            },
            isLoading: false
        }), [
        fieldId,
        fieldLabel,
        templates
    ]);
};
